import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";
import { api } from "../../lib/api";
import { Loader } from "../../components/Loader";
import { PageHeader } from "../../components/PageHeader";

export default function AdminHelpEditor() {
  const [cats, setCats] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api("/help/content").then((d) => { setCats(d.categories || []); setFaqs(d.faqs || []); }).catch(() => { setCats([]); setFaqs([]); });
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api("/admin/help", { method: "PUT", body: JSON.stringify({ categories: cats, faqs }) }); toast.success("تم حفظ محتوى المساعدة"); }
    catch (e) { toast.error(e.message); } finally { setSaving(false); }
  };

  if (cats === null) return <Loader />;

  const setCat = (i, k, v) => setCats(cats.map((c, idx) => idx === i ? { ...c, [k]: v } : c));
  const setFaq = (i, k, v) => setFaqs(faqs.map((f, idx) => idx === i ? { ...f, [k]: v } : f));

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto pb-24">
      <PageHeader title="تعديل المساعدة" backTo="/admin" />

      <h2 className="font-black text-[#161629] mt-2 mb-2">البطاقات</h2>
      <div className="space-y-2">
        {cats.map((c, i) => (
          <div key={i} className="bg-white rounded-2xl border border-[#E8EAF2] p-3">
            <input data-testid={`cat-title-${i}`} value={c.title || ""} onChange={(e) => setCat(i, "title", e.target.value)} placeholder="العنوان" className="w-full font-bold text-right outline-none mb-1" />
            <input value={c.desc || ""} onChange={(e) => setCat(i, "desc", e.target.value)} placeholder="الوصف" className="w-full text-sm text-[#6B7280] text-right outline-none" />
            <button onClick={() => setCats(cats.filter((_, idx) => idx !== i))} className="text-xs text-[#FF3D5A] flex items-center gap-1 mt-2"><Trash2 size={13} /> حذف</button>
          </div>
        ))}
      </div>
      <button data-testid="add-cat" onClick={() => setCats([...cats, { key: `c_${Date.now()}`, title: "", desc: "" }])} className="text-sm flex items-center gap-1 text-[#FF3D5A] font-bold mt-2"><Plus size={16} /> إضافة بطاقة</button>

      <h2 className="font-black text-[#161629] mt-6 mb-2">الأسئلة الشائعة</h2>
      <div className="space-y-2">
        {faqs.map((f, i) => (
          <div key={i} className="bg-white rounded-2xl border border-[#E8EAF2] p-3">
            <input data-testid={`faq-q-${i}`} value={f.q || ""} onChange={(e) => setFaq(i, "q", e.target.value)} placeholder="السؤال" className="w-full font-bold text-right outline-none mb-1" />
            <textarea value={f.a || ""} onChange={(e) => setFaq(i, "a", e.target.value)} placeholder="الإجابة" className="w-full text-sm text-[#6B7280] text-right outline-none resize-none" rows={2} />
            <button onClick={() => setFaqs(faqs.filter((_, idx) => idx !== i))} className="text-xs text-[#FF3D5A] flex items-center gap-1 mt-2"><Trash2 size={13} /> حذف</button>
          </div>
        ))}
      </div>
      <button data-testid="add-faq" onClick={() => setFaqs([...faqs, { q: "", a: "" }])} className="text-sm flex items-center gap-1 text-[#FF3D5A] font-bold mt-2"><Plus size={16} /> إضافة سؤال</button>

      <button data-testid="save-help" disabled={saving} onClick={save} className="fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 px-8 h-12 rounded-2xl bg-[#FF3D5A] text-white font-black disabled:opacity-50"><Save size={18} /> {saving ? "..." : "حفظ"}</button>
    </div>
  );
}
